import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import {
  SigninEmailMfaValidateObject,
  signinEmailMfaValidateObject,
} from './validate'

export function useSigninEmailMfaForm() {
  const signinEmailMfaFormObject = useForm<SigninEmailMfaValidateObject>({
    defaultValues: {
      code: '',
    },
    mode: 'all',
    resolver: zodResolver(signinEmailMfaValidateObject),
  })
  return signinEmailMfaFormObject
}
